import { DateTime } from 'luxon';

export function convertUTCDateToEST(
    utcDate: string | Date | null | undefined,
    dateFormat?: string,
    timezone?: string,
): string {
    if (!utcDate || utcDate === '') {
        return '';
    }

    const timeZone = timezone ? timezone : 'America/New_York';

    const utcDateStr = typeof utcDate === 'string' ? utcDate : utcDate.toISOString();
    const safeUtc = utcDateStr.endsWith('Z') ? utcDateStr : `${utcDateStr}Z`;
    const utcDateTime = DateTime.fromISO(safeUtc, { zone: 'utc' });
    const zonedDateTime = utcDateTime.setZone(timeZone);

    if (zonedDateTime.isValid) {
        const formattedDate = zonedDateTime.toFormat(dateFormat ? dateFormat : 'dd/MM/yyyy');
        return formattedDate;
    } else {
        console.error('Invalid zoned datetime:', utcDateStr);
        return '';
    }
}

export function convertDateFormat(inputStr: string | Date) {
    if (!inputStr || inputStr === '') {
        console.error('Invalid date string provided.');
        return '';
    }
    const estDate = convertUTCDateToEST(inputStr, 'M/d/yyyy h:mm a');
    const inputDate = new Date(estDate);
    let hours = inputDate.getHours() % 12;
    hours = hours === 0 ? 12 : hours;

    const outputStr = `${(inputDate.getMonth() + 1).toString().padStart(2, '0')}/${inputDate
        .getDate()
        .toString()
        .padStart(2, '0')}/${inputDate.getFullYear()} ${hours
        .toString()
        .padStart(2, '0')}:${inputDate.getMinutes().toString().padStart(2, '0')} ${
        inputDate.getHours() >= 12 ? 'PM' : 'AM'
    }`;

    return outputStr;
}

/**
 * Converts a 24-hour time format string to a 12-hour format string with an indication of the time of day.
 *
 * Expected input: A time string in 24-hour format (HH:MM:SS), e.g., '15:30:00'.
 * Expected output: A string representing the time in 12-hour format with AM/PM and the time of day,
 * e.g., 'Afternoon(03:00 PM)'.
 */
export function formatTimeSlots(timeString: string): string {
    let timeOfDay = '';
    const givenHour = parseInt(timeString.split(':')[0], 10);
    const hourForDisplay = givenHour === 12 ? 12 : givenHour % 12;
    const convertedTime = `${hourForDisplay.toString().padStart(2, '0')}:00 ${
        givenHour < 12 ? 'AM' : 'PM'
    }`;

    if (givenHour >= 4 && givenHour < 12) {
        timeOfDay = `Morning(${convertedTime})`;
    } else if (givenHour >= 12 && givenHour < 18) {
        timeOfDay = `Afternoon(${convertedTime})`;
    } else if (givenHour >= 18 && givenHour < 22) {
        timeOfDay = `Evening(${convertedTime})`;
    } else {
        timeOfDay = `Evening(${convertedTime})`;
    }

    return timeOfDay;
}
